exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n.embed_remember-container_3rnp4,\n.embed_remember-warning_2ODLF,\n.embed_sandboxed_2rgpt {\n    margin: 8px 0;\n}\n\n.embed_remember-container_3rnp4 {\n    display: flex;\n    align-items: center;\n}\n\n.embed_remember-checkbox_1peXa {\n    margin-right: 8px;\n}\n\n.embed_remember-warning_2ODLF {\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n    background-color: rgba(255, 81, 81, 0.25);\n    border: 1px solid red;\n}", ""]);

// exports
exports.locals = {
	"remember-container": "embed_remember-container_3rnp4",
	"rememberContainer": "embed_remember-container_3rnp4",
	"remember-warning": "embed_remember-warning_2ODLF",
	"rememberWarning": "embed_remember-warning_2ODLF",
	"sandboxed": "embed_sandboxed_2rgpt",
	"remember-checkbox": "embed_remember-checkbox_1peXa",
	"rememberCheckbox": "embed_remember-checkbox_1peXa"
};